/***
 *  Browser Store Methods
 */  
export const saveStateToLocalStore =  (data) => window.localStorage.setItem('store', JSON.stringify(data));
export const getStateFromLocalStore = () => JSON.parse(
    window.localStorage.getItem('store')
);

export const UUIDv4 = () => {
    /*eslint-disable no-mixed-operators */
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

export const createUUID = () => {
    let uuid;
    // supported by browser
    try {
         uuid = crypto.randomUUID();
    // backup method
    } catch(e) {
        uuid = UUIDv4();
    }
    return uuid;
}

export const calcPrice = price => price.toFixed(2);
export const calcVatAmount = (price, vat) => ( vat.toFixed(2) * price.toFixed(2) );

export const groupBy = (arr, key) => {
        return arr.reduce( (rv, x) => {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
        }, {});
};

export const getordersById = (orders, id) => groupBy([...orders], id);     